module.exports = __webpack_public_path__ + "static/ey-5-sq-503ad6cb21f99039ead07d7485ed702a.png";